<div fxLayout="column" *ngIf="product" class="m-t-20">

  <ng-container *ngIf="!product.callerReferenceKey && productCompany?.code && newAssetInstanceKeyStart && newAssetInstanceTemplateName">
    <div class="m-20" fxLayout="column" fxLayoutAlign="center center">
      
      <h4>Select Existing Asset Instance</h4>

      <button type="button" mat-flat-button color="primary" (click)="selectExistingAssetInstance()">
        Select
      </button>
      
      <h2>OR</h2>
      
      <h4>Create New Asset Instance</h4>

      <div class="new-caller-reference-key">
        {{ newAssetInstanceKeyStart }}{{ newAssetInstanceTemplateName }}\&nbsp;
        <mat-form-field style="width: 400px">
          <input matInput [maxlength]="30"  [(ngModel)]="newAssetInstanceName" (keydown.enter)="onEnterPressNewAssetInstance()" />
        </mat-form-field>
      </div>
      <button type="button" mat-flat-button color="primary" (click)="createAndSetNewAssetInstance()" [disabled]="!newAssetInstanceName">
        Create
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="product.callerReferenceKey">
    <div fxLayout="column" fxLayoutAlign="start stretch">

      <div class="m-l-15 m-r-15" fxLayout="row" fxLayoutAlign="space-between center">
        <span>Caller Reference Key: <small>{{ product.callerReferenceKey }}</small></span>
    
      </div>

      <div fxLayout="row" fxLayoutAlign="start stretch">
        
        <mat-card class="contrast" fxFlex="50">
          <mat-card-content style="padding-right: 0;padding-left: 0;" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">

            <artifact-tree
              [product]="product"
              [productCompany]="productCompany"
              [assetInstanceKey]="product.callerReferenceKey"
              [assetInstances]="assetInstances"
              [assetTemplates]="assetTemplates"
              (findAndReplaceAssetReference)="onFindAndReplaceAssetReference($event)"
              (propertyEdited)="onPropertyEdited($event)"
            ></artifact-tree>

          </mat-card-content>
        </mat-card>

        <mat-card class="contrast" fxFlex="50">
          <mat-card-content style="padding-right: 0;padding-left: 0;">

            <mat-card *ngIf="selectedAssetPropertyDetails">

              <mat-card-header>
                <mat-card-title> 
                    {{ selectedAssetPropertyDetails.assetPropertyTemplate.propertyName }}
                    <small *ngIf="selectedAssetPropertyDetails.assetPropertyTemplate.templateName">({{ selectedAssetPropertyDetails.assetPropertyTemplate.templateName }})</small>
                </mat-card-title>
                <mat-card-subtitle *ngIf="selectedAssetPropertyDetails.assetProperty?.callerReferenceKey">
                  {{ selectedAssetPropertyDetails.assetProperty?.callerReferenceKey }}
                </mat-card-subtitle>
                <button class="close-button" mat-icon-button (click)="clearCurrentSelection()" matTooltip="Clear current selection">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-card-header>
              <mat-card-content fxLayout="column" fxLayoutAlign="start stretch">
                <div *ngIf="assetReferenceRecommendations">

                  <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-form-field>
                      <mat-label>Create New Asset Instance</mat-label>
                      <input matInput [(ngModel)]="assetInstanceSearchTerms" />
                    </mat-form-field>
                    <button mat-icon-button color="accent" (click)="loadAssetReferenceRecommendations()" matTooltip="Search for Asset Recommendations">
                      <mat-icon>search</mat-icon>
                    </button>
                  </div>

                  <h4>Artifacts</h4>

                  <ng-container *ngIf="assetReferenceRecommendations.length > 0 || newAssetReferenceRecommendations.length > 0">
                    <div *ngFor="let assetReferenceRecommendation of assetReferenceRecommendations; let i = index" fxLayout="row" fxLayoutAlign="start center">
                      
                      <button mat-icon-button color="accent" *ngIf="assetReferenceRecommendation.isSelected">
                        <mat-icon>radio_button_checked</mat-icon>
                      </button>
                      <button mat-icon-button color="accent" *ngIf="!assetReferenceRecommendation.isSelected" (click)="selectAssetReferenceRecommendation(assetReferenceRecommendation)">
                        <mat-icon>radio_button_unchecked</mat-icon>
                      </button>
                      <span class="caller-reference-key">{{ assetReferenceRecommendation.callerReferenceKey }}</span>

                      <asset-validation
                        *ngIf="!assetReferenceRecommendation.callerReferenceKey?.startsWith('assetinstance')"
                        [companyId]="product.companyId"
                        [callerReferenceKey]="assetReferenceRecommendation.callerReferenceKey"
                        (validationLoaded)="assetReferenceRecommendation.onAssetValidationCompleted($event)"
                        [autoLoadAssetValidation]="i < 5"
                        >
                      </asset-validation>
                    
                    </div>

                    <div *ngFor="let newAssetReferenceRecommendation of newAssetReferenceRecommendations; let i = index" fxLayout="row" fxLayoutAlign="start center">
                      
                      <button mat-icon-button color="accent" *ngIf="newAssetReferenceRecommendation.isSelected">
                        <mat-icon>radio_button_checked</mat-icon>
                      </button>
                      <button mat-icon-button color="accent" *ngIf="!newAssetReferenceRecommendation.isSelected" (click)="selectNewAssetReferenceRecommendation(newAssetReferenceRecommendation)">
                        <mat-icon>radio_button_unchecked</mat-icon>
                      </button>
                      <span class="caller-reference-key">{{ newAssetReferenceRecommendation.callerReferenceKey }}</span>
                    
                      <asset-validation
                        *ngIf="newAssetReferenceRecommendation.fileVaultReferenceRelation?.id"
                        [companyId]="product.companyId"
                        [fileVaultReferenceRelationId]="newAssetReferenceRecommendation.fileVaultReferenceRelation?.id"
                        [fileVaultHash]="newAssetReferenceRecommendation.fileVaultReferenceRelation?.fileHash"
                        (validationLoaded)="newAssetReferenceRecommendation.onAssetValidationCompleted($event)"
                        [autoLoadAssetValidation]="i < 5"
                        >
                      </asset-validation>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="selectedAssetPropertyDetails.assetPropertyTemplate.assetType === propertyType.TEMPLATE">
                    <div class="m-t-20">
                      <small>Create New Asset Instance</small>
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <div class="new-caller-reference-key">
                          {{ newAssetInstanceKeyStart }}{{ selectedAssetPropertyDetails.assetPropertyTemplate.templateName.toLowerCase() }}\&nbsp;
                          <mat-form-field>
                            <input matInput [maxlength]="30"  [(ngModel)]="newAssetInstanceName" />
                          </mat-form-field>
                        </div>
                        <button type="button" mat-flat-button color="primary" (click)="createAndSetNewAssetInstance()" [disabled]="!newAssetInstanceName">
                          Create
                        </button>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="fileVaultReferenceRecommendations.length > 0">
                    
                    <h4>File Vault Assets</h4>
                    <div *ngFor="let fileVaultReferenceRecommendation of fileVaultReferenceRecommendations; let i = index" fxLayout="row" fxLayoutAlign="start center">
                      
                      <button mat-icon-button color="accent" *ngIf="fileVaultReferenceRecommendation.isSelected" (click)="selectFileVaultReferenceRecommendation(fileVaultReferenceRecommendation)">
                        <mat-icon>check_box</mat-icon>
                      </button>
                      <button mat-icon-button color="accent" *ngIf="!fileVaultReferenceRecommendation.isSelected" (click)="selectFileVaultReferenceRecommendation(fileVaultReferenceRecommendation)">
                        <mat-icon>check_box_outline_blank</mat-icon>
                      </button>
                      <span>{{ fileVaultReferenceRecommendation.fileVaultReferenceRelation.fileName }}</span>
                        
                      <asset-validation
                        [companyId]="fileVaultReferenceRecommendation.fileVaultReferenceRelation.companyId"
                        [fileVaultReferenceRelationId]="fileVaultReferenceRecommendation.fileVaultReferenceRelation.id"
                        [fileVaultHash]="fileVaultReferenceRecommendation.fileVaultReferenceRelation.fileHash"
                        (validationLoaded)="fileVaultReferenceRecommendation.onAssetValidationCompleted($event)"
                        [autoLoadAssetValidation]="i < 5"
                        >
                      </asset-validation>

                    </div>
                  </ng-container>

                  <ng-container *ngIf="newAssetResources.length > 0 || newAssetInstances.length > 0">
                    <h4>New Artifacts</h4>

                    <div *ngIf="newAssetInstances.length > 0">
                      <h5>Asset Instances</h5>
                      <div *ngFor="let newAssetInstance of newAssetInstances" fxLayout="row" fxLayoutAlign="start center">
                        <button mat-icon-button color="accent" *ngIf="newAssetInstance.isSelected" [disabled]="newAssetInstance.selectionDisabled" (click)="newAssetInstance.isSelected = false">
                          <mat-icon>check_box</mat-icon>
                        </button>
                        <button mat-icon-button color="accent" *ngIf="!newAssetInstance.isSelected" [disabled]="newAssetInstance.selectionDisabled" (click)="newAssetInstance.isSelected = true">
                          <mat-icon>check_box_outline_blank</mat-icon>
                        </button>
                        <span class="caller-reference-key">{{ newAssetInstance.callerReferenceKey }}</span>
                      </div>
                    </div>

                    
                    <div *ngIf="newAssetResources.length > 0">
                      <h5>Asset Resources</h5>
                      <div *ngFor="let newFileVaultAssetResource of newAssetResources; let i = index" fxLayout="row" fxLayoutAlign="start center">
                        <button mat-icon-button color="accent" *ngIf="newFileVaultAssetResource.isSelected" [disabled]="newFileVaultAssetResource.selectionDisabled" (click)="newFileVaultAssetResource.isSelected = false">
                          <mat-icon>check_box</mat-icon>
                        </button>
                        <button mat-icon-button color="accent" *ngIf="!newFileVaultAssetResource.isSelected" [disabled]="newFileVaultAssetResource.selectionDisabled" (click)="newFileVaultAssetResource.isSelected = true">
                          <mat-icon>check_box_outline_blank</mat-icon>
                        </button>
                        <span class="caller-reference-key">{{ newFileVaultAssetResource.callerReferenceKey }}</span>
                        
                        <asset-validation
                          [companyId]="newFileVaultAssetResource.fileVaultReferenceRelation.companyId"
                          [fileVaultReferenceRelationId]="newFileVaultAssetResource.fileVaultReferenceRelation.id"
                          [fileVaultHash]="newFileVaultAssetResource.fileVaultReferenceRelation.fileHash"
                          (validationLoaded)="newFileVaultAssetResource.onAssetValidationCompleted($event)"
                          [autoLoadAssetValidation]="true"
                          >
                        </asset-validation>

                      </div>
                    </div>

                  </ng-container>


                  <div class="m-t-20" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">

                    <mat-checkbox *ngIf="newAssetResourcesHasFailures()" [(ngModel)]="confirmationOverridden">
                      <small>Override failed asset validation with comment</small>
                    </mat-checkbox>
                  
                    <button *ngIf="fileVaultReferenceRecommendations.length > 0 && fileVaultReferenceRecommendationsIsSelected()"
                      [disabled]="!selectedFileVaultReferenceRecommendationsIsDifferent() || (newAssetResourcesHasFailures() && !confirmationOverridden)"
                      type="button" mat-flat-button color="primary" (click)="confirmSelectedFileVaultReferenceRecommendation()">
                      Confirm Selection
                    </button>
                  
                    <button *ngIf="(assetReferenceRecommendations.length > 0 || newAssetReferenceRecommendations.length > 0) && assetReferenceRecommendationIsSelected()"
                      [disabled]="!selectedAssetReferenceRecommendationIsDifferent()"
                      type="button" mat-flat-button color="primary" (click)="confirmSelectedAssetReferenceRecommendation()">
                      Confirm Selection
                    </button>
                  
                  </div>

                </div>
              </mat-card-content>
              
            </mat-card>

            <mat-card *ngIf="!selectedAssetPropertyDetails">

              <mat-card-header>
                <mat-card-title>
                  Automated Actions
                </mat-card-title>
              </mat-card-header>

              <mat-card-content fxLayout="column" fxLayoutAlign="start stretch">

                <div class="m-t-20" fxLayout="column" fxLayoutAlign="center end">
                  <button [disabled]="!canBuildArtifactsFromAssets()" type="button" mat-flat-button color="primary" (click)="buildArtifactsFromAssets()">
                    Build Artifacts From Assets
                  </button>
                </div>

              </mat-card-content>
            </mat-card>

            <mat-card>
              <mat-card-content>

                <mat-card-title>
                  Artifact Publish Queue
                </mat-card-title>

                <div *ngIf="publishQueueAssetInstances.length > 0">
                  <h5>Asset Instances</h5>
                  <div *ngFor="let publishQueueAssetInstance of publishQueueAssetInstances" fxLayout="row" fxLayoutAlign="start center">

                    
                    <button mat-icon-button color="accent" *ngIf="publishQueueAssetInstance.isSelected" (click)="publishQueueAssetInstance.isSelected = false">
                      <mat-icon>check_box</mat-icon>
                    </button>
                    <button mat-icon-button color="accent" *ngIf="!publishQueueAssetInstance.isSelected" (click)="publishQueueAssetInstance.isSelected = true">
                      <mat-icon>check_box_outline_blank</mat-icon>
                    </button>

                    <span class="caller-reference-key"> {{ publishQueueAssetInstance.callerReferenceKey }} </span>
                  </div>
                </div>

                <div *ngIf="publishQueueAssetResources.length > 0">
                  <h5>Asset Resources</h5>
                  <div *ngFor="let publishQueueAssetResource of publishQueueAssetResources" fxLayout="row" fxLayoutAlign="start center">

                    <button mat-icon-button color="accent" *ngIf="publishQueueAssetResource.isSelected" (click)="publishQueueAssetResource.isSelected = false">
                      <mat-icon>check_box</mat-icon>
                    </button>
                    <button mat-icon-button color="accent" *ngIf="!publishQueueAssetResource.isSelected" (click)="publishQueueAssetResource.isSelected = true">
                      <mat-icon>check_box_outline_blank</mat-icon>
                    </button>

                    <span class="caller-reference-key">{{ publishQueueAssetResource.callerReferenceKey }} </span>
                    
                    <asset-validation
                      [companyId]="publishQueueAssetResource.fileVaultReferenceRelation.companyId"
                      [fileVaultReferenceRelationId]="publishQueueAssetResource.fileVaultReferenceRelation.id"
                      [fileVaultHash]="publishQueueAssetResource.fileVaultReferenceRelation.fileHash"
                      (validationLoaded)="publishQueueAssetResource.onAssetValidationCompleted($event)"
                      [autoLoadAssetValidation]="true"
                      >
                    </asset-validation>
                  </div>
                </div>

                <mat-form-field>
                  <h5>Publish Comments</h5>
                  <span style="white-space: pre-line">{{ buildReadOnlyPublishComment() }}</span>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="publishComment"></textarea>
                </mat-form-field>

                <div class="m-t-20" fxLayout="column" fxLayoutAlign="center end">
                  <button type="button" mat-flat-button color="primary" (click)="publishProductAsset()" [disabled]="!canPublish()">
                    Publish Assets
                  </button>
                </div>

              </mat-card-content>

            </mat-card>

          </mat-card-content>
        </mat-card>
      </div>


      
    </div>
    
  </ng-container>
</div>